import { api } from 'src/api';
import { APPLICATION_VERSION } from 'src/error/config/sentry/runTimeConfig';
import { dataLayerPush } from 'src/helpers/gtm';
import { getUserId } from 'src/utils/getUserId';
import type {
  AuthFormType,
  AuthMethodsForAnalytics,
  LoginFormTypeForAnalytics,
} from './types';
import { AuthEnumToAnalytics } from './types';

export const pushAuthOpen = () => {
  dataLayerPush({ event: 'auth_open' });
};

export const pushAuthContinue = (type: LoginFormTypeForAnalytics) => {
  dataLayerPush({ event: 'auth_continue', type });
};

export const pushAuthSuccessful = (loginMethod: AuthMethodsForAnalytics) => {
  dataLayerPush({ event: 'auth_success', type: loginMethod });

  // Аналитка для партнера sutochno
  if (window.PARTNER?.id === 1168) {
    window._paq.push([
      'trackEvent',
      'Auth',
      'Success',
      window.ORDER.id || window.PACKAGE.id,
    ]);
    window.ym(8562148, 'reachGoal', 'sutochno.level.travel_AuthSuccess');
  }
};

export const pushAuthPageView = async (
  stepName: AuthFormType,
  isMobile: boolean,
) => {
  try {
    const clientData = { uuid: getUserId() };
    const { referrer } = document;
    const partnerId = window.PARTNER ? window.PARTNER.id : null;

    if (!stepName) return;
    if (!APPLICATION_VERSION)
      throw new Error('No application version provided!');

    await api.postStatsPageview({
      client: clientData,
      is_mobile: isMobile,
      referrer,
      partner_id: partnerId,
      step_name: AuthEnumToAnalytics[stepName],
      release_version: APPLICATION_VERSION,
      url: window.location.href,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};
